import React from 'react';
import { UserAuth } from '../context/AuthContext';
import PoomDataTable from './datatable/PoomDataTable';
import { Typography } from '@material-tailwind/react';

const Account = () => {
  const { user } = UserAuth();

  return (
    <div>
      <div className="container mx-auto px-4 pt-6">
        <div className="flex justify-center">
          <div className="grid auto-cols-auto content-center">
            <Typography variant="h6" className="text-center">
              User Email: {user && user.email}
            </Typography>
            <div
              className="text-center pt-2 pb-4"
            ></div>
          </div>
        </div>
        <PoomDataTable />
      </div>
    </div>
  );
};

export default Account;
